// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonial-one img {
    display: unset !important;
    width: 90%;
  }
  .coinDetails-datepiker .picker__container {
    position: relative !important;
  }
  .wallet-card {
    margin: 0 auto;
    width: 95% !important;
  }
  .dataTables_wrapper .dataTables_paginate span .paginate_button {
    display: inline-block;
  }
  .sidebar-right
    .tab-content
    .tab-pane
    .admin-settings
    input[type="radio"]:checked
    + label::after {
    background-color: rgba(1, 1, 1, 0) !important;
  }
  /* ////////////////////////fixed */
  .element-right-round button#dropdown-button-drop-dwon {
    border-radius: 0 0.75rem 0.75rem 0;
  }
  ._i-hover:hover {
    left: 0 !important;
  }
  @media screen and (min-width: 695px) {
    .d-unset {
      display: unset !important;
    }
  }
  .d-unset {
    display: block;
  }
  button#check-minutes {
    border-radius: 0 0.75rem 0.75rem 0;
  }
  .fc-toolbar-chunk {
    display: flex;
  }
  @media screen and (max-width: 335px) {
    .fc-toolbar-chunk {
      display: block;
      text-align: center;
      line-height: 2.8;
    }
    .fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
      margin: 0 !important;
    }
  }
  /* Editor */
  .tox .tox-notification--warn,
  .tox .tox-notification--warning {
    display: none !important;
  }
  
  /* Map */
  svg.svg-map {
    stroke: white !important;
  }
  .svg-map__location {
    fill: #eff2f4 !important;
  }
  .svg-map__location:focus,
  .svg-map__location:hover {
    fill: black !important;
  }
  
  .p-meddle {
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
  }
  /* color picker */
  
  .chrome-picker {
    position: absolute;
    top: -310px;
  }
  .color-gradian-tixia .popover {
    top: -410px !important;
  }
  /* wizard */
  
  /* date piker */
  @media screen and (max-width: 590px) {
    .rangeDatePicker .calendar__item {
      display: block !important;
      width: 100%;
    }
    .rangeDatePicker .calendar__container {
      width: 100% !important;
    }
  }
  
  form#step-form-horizontal div:first-child > div:last-child {
    text-align: right;
    /* padding-top: 2rem; */
  }
  
  label.mailclinet {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 10rem;
    height: 10rem;
    border-radius: 50%;
    cursor: pointer;
    background-color: #eef5f9;
    text-align: center;
    margin: auto;
  }
  
  .wizard-four-color {
    color: #222fb9;
    text-decoration: underline;
  }
  
  .redio-false {
    display: none;
  }
  
  span.mail-icon {
    font-size: 3rem;
    display: inline-block;
    line-height: 1;
    margin-top: -1rem;
  }
  
  span.mail-text {
    font-size: 1rem;
    text-align: center;
    margin-top: 0.5rem;
  }
  
  /* Wizard end */
  
  /* cursor-pointer */
  .cursor-pointer {
    cursor: pointer;
  }
  /* form */
  #multiselect button.btn.dropdown-toggle.btn-light {
    background: no-repeat;
    border: 1px solid #d7dae3;
    color: #3e4954;
    font-weight: 100;
  }
  /* slider */
  
  .card-text {
    margin-bottom: 0;
  }
  #whiteSpace {
    white-space: normal;
  }
  
  #tp-btn::after {
    content: "";
  }
  
  .swal-footer {
    text-align: center !important;
    margin: 0 !important;
  }
  
  .ui .progress .progress-bar {
    animation-name: animateBar;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.6s;
  }
  @keyframes animateBar {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  ol.go2441762052 {
    text-align: center;
  }
  
  #order2 {
    order: 2;
  }
  
  /* Editor */
  
  .summernote > :first-child {
    min-height: 250px;
    border: 1px solid #a9a9a9;
    border-color: #f0f1f5;
  }
  .rdw-image-modal {
    right: 0 !important;
    left: unset !important;
  }
  .rdw-editor-toolbar {
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
  }
  
  /* Button */
  button:focus,
  a:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  
  /* Chart */
  
  .go2478912419 {
    text-align: center;
    display: block;
    margin-bottom: 2rem;
  }
  
  .picker-input__text,
  .range-picker-input {
    width: 100% !important;
  }
  
  .timepicker-container,
  .MuiFormControl-root.MuiTextField-root {
    flex: 1 1 auto;
  }
  
  .timepicker-container input {
    background: #fff;
    border: 1px solid #f0f1f5;
    color: #b1b1b1;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    height: 41px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .MuiFormControl-root.MuiTextField-root {
    display: block;
  }
  .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-formControl.MuiInput-formControl {
    width: 100%;
    height: 100%;
  }
  
  .dd .nestable-item-name {
    color: #fff;
    background: #363062;
    display: block;
    height: 30px;
    margin: 5px 0;
    padding: 5px 10px;
    text-decoration: none;
    font-weight: 700;
    border: 1px solid #ccc;
    border-radius: 3px;
    box-sizing: border-box;
    font-size: 13px;
    margin-bottom: -4px;
  }
  
  /* Picker */
  
  .i-false:after {
    content: none !important;
  }
  
  rect#chart_ChartBorder {
    fill: transparent;
  }
  
  /* pagination */
  .pagination {
    margin-bottom: 0 !important;
  }
  .rc-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 80;
  }
  .rc-backdrop.invert {
    background: rgba(1, 1, 1, 0.7);
  }
  .range-picker-input {
    display: inline-flex;
    border: 1px solid #e4e4e4;
    width: 300px;
  }
  .range-picker-input * {
    box-sizing: border-box;
  }
  .range-picker-input__icon {
    display: inline-flex;
    align-items: center;
  }
  .range-picker-input__start,
  .range-picker-input__end {
    display: inline-flex;
    flex: 1 1;
  }
  .range-picker-input__start .picker-input.range input,
  .range-picker-input__end .picker-input.range input {
    width: 100%;
    border: none;
  }
  .picker-input {
    display: inline-block;
    position: relative;
  }
  .picker-input__icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    display: inline-flex;
    align-items: center;
  }
  .picker-input__text {
    padding: 10px;
    border: 1px solid #e4e4e4;
    outline: none;
    font-size: 16.8px;
  }
  .picker-input__text:disabled {
    background: #e4e4e4;
  }
  .picker-input__clear {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    cursor: pointer;
  }
  .picker {
    display: inline-block;
  }
  .picker__container {
    position: absolute;
    z-index: 100;
  }
  .picker__container.portal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .picker__container__include-time {
    border: 1px solid #e4e4e4;
  }
  .picker__container__include-time .calendar__item,
  .picker__container__include-time .time__container {
    border: none;
  }
  .picker__container__tab {
    margin: 10px 0;
  }
  .picker__container__tab button {
    padding: 5px 10px;
    outline: none;
    display: inline-flex;
    align-items: center;
    background: none;
    border: none;
    border-bottom: 2px solid #e4e4e4;
  }
  .picker__container__tab button.active {
    color: #49599a;
    border-bottom: 2px solid #49599a;
  }
  .picker__container__tab button:first-child {
    border-right: none;
  }
  .picker__container__tab button svg {
    margin-right: 5px;
  }
  .time__container {
    display: inline-flex;
    align-items: center;
    border: 1px solid #e4e4e4;
    padding: 15px;
    background: white;
    font-family: "Lato";
    font-size: 12px;
  }
  .time__container__div {
    margin: 0 10px;
  }
  .time__container__type {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
  }
  .time-input {
    display: inline-block;
    width: 40px;
    overflow: hidden;
  }
  .time-input__up,
  .time-input__down {
    border: 1px solid #e4e4e4;
  }
  .time-input__up button,
  .time-input__down button {
    outline: none;
    width: 100%;
    cursor: pointer;
    border: none;
  }
  .time-input__text {
    width: 100%;
    border-left: 1px solid #e4e4e4;
    border-right: 1px solid #e4e4e4;
    box-sizing: border-box;
  }
  .time-input__text input {
    width: 100%;
    box-sizing: border-box;
    border: none;
    font-size: 15px;
    padding: 5px;
    text-align: center;
    outline: none;
  }
  
  /* calender */
  
  .react-calendar {
    border: none !important;
    font-family: "poppins", sans-serif;
  }
  
  abbr[title],
  abbr[data-original-title] {
    text-decoration: none !important;
  }
  button.react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day--neighboringMonth {
    color: #dee2e6 !important;
    font-family: "poppins", sans-serif;
  }
  
  span.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
    font-size: 20px;
    font-weight: 500;
    color: #000;
    font-family: "poppins", sans-serif;
  }
  button.react-calendar__navigation__arrow.react-calendar__navigation__prev-button,
  button.react-calendar__navigation__arrow.react-calendar__navigation__next-button {
    display: none;
  }
  
  button.react-calendar__tile.react-calendar__month-view__days__day {
    border-radius: 10px;
    color: black;
    color: #000;
    font-weight: 500;
    height: 46px;
    line-height: 30px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "poppins", sans-serif;
  }
  button.react-calendar__navigation__label {
    /* padding: 20px 15px; */
    border-radius: 1.75rem !important;
    font-size: 20px;
  }
  button.react-calendar__navigation__label:hover {
    color: white !important;
    background: #eeeeee !important;
  }
  button.react-calendar__navigation__label:hover > span {
    /* color: white !important; */
    /* background: #EEEEEE !important; */
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus,
  .react-calendar__navigation__label:hover > span {
    /* background-color: #eeeeee !important; */
    /* color: white; */
    /* border-radius: 50%; */
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus,
  .react-calendar__tile--hasActive,
  .react-calendar__navigation button[disabled],
  .react-calendar__navigation button[disabled] > span {
    background-color: #eeeeee !important;
  
    /* color: white; */
  }
  button.react-calendar__tile.react-calendar__tile--now.react-calendar__month-view__days__day,
  button.react-calendar__tile.react-calendar__tile--active.react-calendar__tile--range.react-calendar__tile--rangeStart.react-calendar__tile--rangeEnd.react-calendar__tile--rangeBothEnds.react-calendar__month-view__days__day {
    position: relative;
    background: #eeeeee !important;
    box-shadow: none;
    /* color: white !important; */
    border-radius: 10px;
    overflow: unset !important;
    padding: 16px 5px 15px 5px;
    /* border-radius: 35px; */
    line-height: 1;
  }
  
  .react-calendar {
    border: none;
  }
  
  .calendar {
    display: inline-block;
    background: white;
    font-size: 12px;
  }
  .calendar *,
  .calendar *:before,
  .calendar *:after {
    box-sizing: border-box;
  }
  .calendar__container {
    width: 270px;
    font-family: "Roboto", sans-serif;
    display: none;
  }
  .calendar__list {
    display: table;
  }
  .calendar__item {
    display: table-cell;
    border: 1px solid #ececec;
  }
  .calendar__item:not(:first-child) {
    border-left: none !important;
  }
  .calendar--show {
    display: inline-block;
  }
  .calendar__head {
    position: relative;
    background: #7986cb;
    padding: 10px 6px;
  }
  .calendar__head--title {
    font-size: 1.3em;
    color: white;
    text-align: center;
    margin: 4px;
  }
  .calendar__head--button {
    outline: none;
    border: none;
    cursor: pointer;
    background: none;
    font-size: 20px;
  }
  .calendar__head--button svg {
    fill: white;
  }
  .calendar__head--prev,
  .calendar__head--next {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }
  .calendar__head--prev {
    left: 0;
  }
  .calendar__head--next {
    right: 0;
  }
  .calendar__panel--show {
    display: block !important;
  }
  .calendar__panel--today {
    background: #aab6fe;
    padding: 5px;
    display: none;
  }
  .calendar__panel--today h2 {
    margin: 0;
    cursor: pointer;
    font-size: 12px;
    text-align: center;
  }
  .calendar__body--table {
    width: 100%;
    table-layout: fixed;
    text-align: center;
    border-spacing: none;
    border-collapse: collapse;
  }
  .calendar__body--table th {
    height: 30px;
    vertical-align: middle;
    color: #212121;
  }
  .calendar__day {
    vertical-align: top;
    padding-top: 5px;
    height: 40px;
    cursor: pointer;
  }
  /* .calendar__day self:hover:not(&--disabled) {
     background: #aab6fe;
     cursor: pointer;
  } */
  .calendar__day--0 {
    color: red;
  }
  .calendar__day--6 {
    color: blue;
  }
  .calendar__day--today {
    background: #fff9c4;
  }
  .calendar__day--disabled {
    color: #ddd;
    cursor: initial;
  }
  .calendar__day--start,
  .calendar__day--end,
  .calendar__day--selected {
    background: #7986cb;
    color: #fff;
  }
  .calendar__day--start:hover,
  .calendar__day--end:hover,
  .calendar__day--selected:hover {
    background: #7986cb;
  }
  .calendar__day--range {
    background: #dce1ff;
  }
  .calendar__day--text {
    display: block;
    font-size: 10px;
  }
  .calendar__year,
  .calendar__month {
    height: 55px;
    vertical-align: middle;
  }
  .calendar__year:hover,
  .calendar__month:hover {
    background: #aab6fe;
    cursor: pointer;
  }
  
  /* Selector Design */
  .css-1okebmr-indicatorSeparator {
    display: none;
  }
  
  /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/jsx/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;;;;;;IAME,6CAA6C;EAC/C;EACA,kCAAkC;EAClC;IACE,kCAAkC;EACpC;EACA;IACE,kBAAkB;EACpB;EACA;IACE;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,cAAc;EAChB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,aAAa;EACf;EACA;IACE;MACE,cAAc;MACd,kBAAkB;MAClB,gBAAgB;IAClB;IACA;MACE,oBAAoB;IACtB;EACF;EACA,WAAW;EACX;;IAEE,wBAAwB;EAC1B;;EAEA,QAAQ;EACR;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,QAAQ;IAER,2BAA2B;IAC3B,WAAW;EACb;EACA,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA,WAAW;;EAEX,eAAe;EACf;IACE;MACE,yBAAyB;MACzB,WAAW;IACb;IACA;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,eAAe;;EAEf,mBAAmB;EACnB;IACE,eAAe;EACjB;EACA,SAAS;EACT;IACE,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;EACA,WAAW;;EAEX;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;EAC1B;EACA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,wBAAwB;IAC1B;EACF;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA,WAAW;;EAEX;IACE,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA,WAAW;EACX;;IAEE,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA,UAAU;;EAEV;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;EACrB;;EAEA,WAAW;;EAEX;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA,eAAe;EACf;IACE,2BAA2B;EAC7B;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;;IAEE,oBAAoB;IACpB,SAAO;EACT;EACA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,4CAA4C;EAC9C;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;EAClC;EACA;IACE,cAAc;IACd,gCAAgC;EAClC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,gBAAgB;EAClB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,aAAa;IACb,WAAW;IACX,eAAe;IACf,YAAY;EACd;EACA;IACE,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA,aAAa;;EAEb;IACE,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;EACA;IACE,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kCAAkC;EACpC;EACA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;EACpC;EACA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;EACA;;;IAGE,0CAA0C;IAC1C,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;;;;;IAKE,oCAAoC;;IAEpC,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;EACjB;EACA;;;IAGE,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,iCAAiC;IACjC,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;;IAEE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,OAAO;EACT;EACA;IACE,QAAQ;EACV;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;EACA;IACE,SAAS;IACT,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;EACA;;;KAGG;EACH;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;;;IAGE,mBAAmB;IACnB,WAAW;EACb;EACA;;;IAGE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;;IAEE,YAAY;IACZ,sBAAsB;EACxB;EACA;;IAEE,mBAAmB;IACnB,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,aAAa;EACf;;EAEA,gCAAgC;AAClC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B","sourcesContent":[".testimonial-one img {\n    display: unset !important;\n    width: 90%;\n  }\n  .coinDetails-datepiker .picker__container {\n    position: relative !important;\n  }\n  .wallet-card {\n    margin: 0 auto;\n    width: 95% !important;\n  }\n  .dataTables_wrapper .dataTables_paginate span .paginate_button {\n    display: inline-block;\n  }\n  .sidebar-right\n    .tab-content\n    .tab-pane\n    .admin-settings\n    input[type=\"radio\"]:checked\n    + label::after {\n    background-color: rgba(1, 1, 1, 0) !important;\n  }\n  /* ////////////////////////fixed */\n  .element-right-round button#dropdown-button-drop-dwon {\n    border-radius: 0 0.75rem 0.75rem 0;\n  }\n  ._i-hover:hover {\n    left: 0 !important;\n  }\n  @media screen and (min-width: 695px) {\n    .d-unset {\n      display: unset !important;\n    }\n  }\n  .d-unset {\n    display: block;\n  }\n  button#check-minutes {\n    border-radius: 0 0.75rem 0.75rem 0;\n  }\n  .fc-toolbar-chunk {\n    display: flex;\n  }\n  @media screen and (max-width: 335px) {\n    .fc-toolbar-chunk {\n      display: block;\n      text-align: center;\n      line-height: 2.8;\n    }\n    .fc-direction-ltr .fc-toolbar > * > :not(:first-child) {\n      margin: 0 !important;\n    }\n  }\n  /* Editor */\n  .tox .tox-notification--warn,\n  .tox .tox-notification--warning {\n    display: none !important;\n  }\n  \n  /* Map */\n  svg.svg-map {\n    stroke: white !important;\n  }\n  .svg-map__location {\n    fill: #eff2f4 !important;\n  }\n  .svg-map__location:focus,\n  .svg-map__location:hover {\n    fill: black !important;\n  }\n  \n  .p-meddle {\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 100%;\n  }\n  /* color picker */\n  \n  .chrome-picker {\n    position: absolute;\n    top: -310px;\n  }\n  .color-gradian-tixia .popover {\n    top: -410px !important;\n  }\n  /* wizard */\n  \n  /* date piker */\n  @media screen and (max-width: 590px) {\n    .rangeDatePicker .calendar__item {\n      display: block !important;\n      width: 100%;\n    }\n    .rangeDatePicker .calendar__container {\n      width: 100% !important;\n    }\n  }\n  \n  form#step-form-horizontal div:first-child > div:last-child {\n    text-align: right;\n    /* padding-top: 2rem; */\n  }\n  \n  label.mailclinet {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    width: 10rem;\n    height: 10rem;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: #eef5f9;\n    text-align: center;\n    margin: auto;\n  }\n  \n  .wizard-four-color {\n    color: #222fb9;\n    text-decoration: underline;\n  }\n  \n  .redio-false {\n    display: none;\n  }\n  \n  span.mail-icon {\n    font-size: 3rem;\n    display: inline-block;\n    line-height: 1;\n    margin-top: -1rem;\n  }\n  \n  span.mail-text {\n    font-size: 1rem;\n    text-align: center;\n    margin-top: 0.5rem;\n  }\n  \n  /* Wizard end */\n  \n  /* cursor-pointer */\n  .cursor-pointer {\n    cursor: pointer;\n  }\n  /* form */\n  #multiselect button.btn.dropdown-toggle.btn-light {\n    background: no-repeat;\n    border: 1px solid #d7dae3;\n    color: #3e4954;\n    font-weight: 100;\n  }\n  /* slider */\n  \n  .card-text {\n    margin-bottom: 0;\n  }\n  #whiteSpace {\n    white-space: normal;\n  }\n  \n  #tp-btn::after {\n    content: \"\";\n  }\n  \n  .swal-footer {\n    text-align: center !important;\n    margin: 0 !important;\n  }\n  \n  .ui .progress .progress-bar {\n    animation-name: animateBar;\n    animation-iteration-count: 1;\n    animation-timing-function: ease-in;\n    animation-duration: 0.6s;\n  }\n  @keyframes animateBar {\n    0% {\n      transform: translateX(-100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n  ol.go2441762052 {\n    text-align: center;\n  }\n  \n  #order2 {\n    order: 2;\n  }\n  \n  /* Editor */\n  \n  .summernote > :first-child {\n    min-height: 250px;\n    border: 1px solid #a9a9a9;\n    border-color: #f0f1f5;\n  }\n  .rdw-image-modal {\n    right: 0 !important;\n    left: unset !important;\n  }\n  .rdw-editor-toolbar {\n    border-top: 0 !important;\n    border-left: 0 !important;\n    border-right: 0 !important;\n  }\n  \n  /* Button */\n  button:focus,\n  a:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n  \n  /* Chart */\n  \n  .go2478912419 {\n    text-align: center;\n    display: block;\n    margin-bottom: 2rem;\n  }\n  \n  .picker-input__text,\n  .range-picker-input {\n    width: 100% !important;\n  }\n  \n  .timepicker-container,\n  .MuiFormControl-root.MuiTextField-root {\n    flex: 1 1 auto;\n  }\n  \n  .timepicker-container input {\n    background: #fff;\n    border: 1px solid #f0f1f5;\n    color: #b1b1b1;\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    height: 41px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  .MuiFormControl-root.MuiTextField-root {\n    display: block;\n  }\n  .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-formControl.MuiInput-formControl {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .dd .nestable-item-name {\n    color: #fff;\n    background: #363062;\n    display: block;\n    height: 30px;\n    margin: 5px 0;\n    padding: 5px 10px;\n    text-decoration: none;\n    font-weight: 700;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    box-sizing: border-box;\n    font-size: 13px;\n    margin-bottom: -4px;\n  }\n  \n  /* Picker */\n  \n  .i-false:after {\n    content: none !important;\n  }\n  \n  rect#chart_ChartBorder {\n    fill: transparent;\n  }\n  \n  /* pagination */\n  .pagination {\n    margin-bottom: 0 !important;\n  }\n  @import url(\"https://fonts.googleapis.com/css?family=Lato\");\n  .rc-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 80;\n  }\n  .rc-backdrop.invert {\n    background: rgba(1, 1, 1, 0.7);\n  }\n  .range-picker-input {\n    display: inline-flex;\n    border: 1px solid #e4e4e4;\n    width: 300px;\n  }\n  .range-picker-input * {\n    box-sizing: border-box;\n  }\n  .range-picker-input__icon {\n    display: inline-flex;\n    align-items: center;\n  }\n  .range-picker-input__start,\n  .range-picker-input__end {\n    display: inline-flex;\n    flex: 1;\n  }\n  .range-picker-input__start .picker-input.range input,\n  .range-picker-input__end .picker-input.range input {\n    width: 100%;\n    border: none;\n  }\n  .picker-input {\n    display: inline-block;\n    position: relative;\n  }\n  .picker-input__icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 10px;\n    display: inline-flex;\n    align-items: center;\n  }\n  .picker-input__text {\n    padding: 10px;\n    border: 1px solid #e4e4e4;\n    outline: none;\n    font-size: 16.8px;\n  }\n  .picker-input__text:disabled {\n    background: #e4e4e4;\n  }\n  .picker-input__clear {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 10px;\n    cursor: pointer;\n  }\n  .picker {\n    display: inline-block;\n  }\n  .picker__container {\n    position: absolute;\n    z-index: 100;\n  }\n  .picker__container.portal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n  }\n  .picker__container__include-time {\n    border: 1px solid #e4e4e4;\n  }\n  .picker__container__include-time .calendar__item,\n  .picker__container__include-time .time__container {\n    border: none;\n  }\n  .picker__container__tab {\n    margin: 10px 0;\n  }\n  .picker__container__tab button {\n    padding: 5px 10px;\n    outline: none;\n    display: inline-flex;\n    align-items: center;\n    background: none;\n    border: none;\n    border-bottom: 2px solid #e4e4e4;\n  }\n  .picker__container__tab button.active {\n    color: #49599a;\n    border-bottom: 2px solid #49599a;\n  }\n  .picker__container__tab button:first-child {\n    border-right: none;\n  }\n  .picker__container__tab button svg {\n    margin-right: 5px;\n  }\n  .time__container {\n    display: inline-flex;\n    align-items: center;\n    border: 1px solid #e4e4e4;\n    padding: 15px;\n    background: white;\n    font-family: \"Lato\";\n    font-size: 12px;\n  }\n  .time__container__div {\n    margin: 0 10px;\n  }\n  .time__container__type {\n    display: flex;\n    flex-direction: column;\n    margin-left: 10px;\n  }\n  .time-input {\n    display: inline-block;\n    width: 40px;\n    overflow: hidden;\n  }\n  .time-input__up,\n  .time-input__down {\n    border: 1px solid #e4e4e4;\n  }\n  .time-input__up button,\n  .time-input__down button {\n    outline: none;\n    width: 100%;\n    cursor: pointer;\n    border: none;\n  }\n  .time-input__text {\n    width: 100%;\n    border-left: 1px solid #e4e4e4;\n    border-right: 1px solid #e4e4e4;\n    box-sizing: border-box;\n  }\n  .time-input__text input {\n    width: 100%;\n    box-sizing: border-box;\n    border: none;\n    font-size: 15px;\n    padding: 5px;\n    text-align: center;\n    outline: none;\n  }\n  \n  /* calender */\n  \n  .react-calendar {\n    border: none !important;\n    font-family: \"poppins\", sans-serif;\n  }\n  \n  abbr[title],\n  abbr[data-original-title] {\n    text-decoration: none !important;\n  }\n  button.react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day--neighboringMonth {\n    color: #dee2e6 !important;\n    font-family: \"poppins\", sans-serif;\n  }\n  \n  span.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {\n    font-size: 20px;\n    font-weight: 500;\n    color: #000;\n    font-family: \"poppins\", sans-serif;\n  }\n  button.react-calendar__navigation__arrow.react-calendar__navigation__prev-button,\n  button.react-calendar__navigation__arrow.react-calendar__navigation__next-button {\n    display: none;\n  }\n  \n  button.react-calendar__tile.react-calendar__month-view__days__day {\n    border-radius: 10px;\n    color: black;\n    color: #000;\n    font-weight: 500;\n    height: 46px;\n    line-height: 30px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: \"poppins\", sans-serif;\n  }\n  button.react-calendar__navigation__label {\n    /* padding: 20px 15px; */\n    border-radius: 1.75rem !important;\n    font-size: 20px;\n  }\n  button.react-calendar__navigation__label:hover {\n    color: white !important;\n    background: #eeeeee !important;\n  }\n  button.react-calendar__navigation__label:hover > span {\n    /* color: white !important; */\n    /* background: #EEEEEE !important; */\n  }\n  .react-calendar__navigation button:enabled:hover,\n  .react-calendar__navigation button:enabled:focus,\n  .react-calendar__navigation__label:hover > span {\n    /* background-color: #eeeeee !important; */\n    /* color: white; */\n    /* border-radius: 50%; */\n  }\n  .react-calendar__tile:enabled:hover,\n  .react-calendar__tile:enabled:focus,\n  .react-calendar__tile--hasActive,\n  .react-calendar__navigation button[disabled],\n  .react-calendar__navigation button[disabled] > span {\n    background-color: #eeeeee !important;\n  \n    /* color: white; */\n  }\n  button.react-calendar__tile.react-calendar__tile--now.react-calendar__month-view__days__day,\n  button.react-calendar__tile.react-calendar__tile--active.react-calendar__tile--range.react-calendar__tile--rangeStart.react-calendar__tile--rangeEnd.react-calendar__tile--rangeBothEnds.react-calendar__month-view__days__day {\n    position: relative;\n    background: #eeeeee !important;\n    box-shadow: none;\n    /* color: white !important; */\n    border-radius: 10px;\n    overflow: unset !important;\n    padding: 16px 5px 15px 5px;\n    /* border-radius: 35px; */\n    line-height: 1;\n  }\n  \n  .react-calendar {\n    border: none;\n  }\n  \n  .calendar {\n    display: inline-block;\n    background: white;\n    font-size: 12px;\n  }\n  .calendar *,\n  .calendar *:before,\n  .calendar *:after {\n    box-sizing: border-box;\n  }\n  .calendar__container {\n    width: 270px;\n    font-family: \"Roboto\", sans-serif;\n    display: none;\n  }\n  .calendar__list {\n    display: table;\n  }\n  .calendar__item {\n    display: table-cell;\n    border: 1px solid #ececec;\n  }\n  .calendar__item:not(:first-child) {\n    border-left: none !important;\n  }\n  .calendar--show {\n    display: inline-block;\n  }\n  .calendar__head {\n    position: relative;\n    background: #7986cb;\n    padding: 10px 6px;\n  }\n  .calendar__head--title {\n    font-size: 1.3em;\n    color: white;\n    text-align: center;\n    margin: 4px;\n  }\n  .calendar__head--button {\n    outline: none;\n    border: none;\n    cursor: pointer;\n    background: none;\n    font-size: 20px;\n  }\n  .calendar__head--button svg {\n    fill: white;\n  }\n  .calendar__head--prev,\n  .calendar__head--next {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n  }\n  .calendar__head--prev {\n    left: 0;\n  }\n  .calendar__head--next {\n    right: 0;\n  }\n  .calendar__panel--show {\n    display: block !important;\n  }\n  .calendar__panel--today {\n    background: #aab6fe;\n    padding: 5px;\n    display: none;\n  }\n  .calendar__panel--today h2 {\n    margin: 0;\n    cursor: pointer;\n    font-size: 12px;\n    text-align: center;\n  }\n  .calendar__body--table {\n    width: 100%;\n    table-layout: fixed;\n    text-align: center;\n    border-spacing: none;\n    border-collapse: collapse;\n  }\n  .calendar__body--table th {\n    height: 30px;\n    vertical-align: middle;\n    color: #212121;\n  }\n  .calendar__day {\n    vertical-align: top;\n    padding-top: 5px;\n    height: 40px;\n    cursor: pointer;\n  }\n  /* .calendar__day self:hover:not(&--disabled) {\n     background: #aab6fe;\n     cursor: pointer;\n  } */\n  .calendar__day--0 {\n    color: red;\n  }\n  .calendar__day--6 {\n    color: blue;\n  }\n  .calendar__day--today {\n    background: #fff9c4;\n  }\n  .calendar__day--disabled {\n    color: #ddd;\n    cursor: initial;\n  }\n  .calendar__day--start,\n  .calendar__day--end,\n  .calendar__day--selected {\n    background: #7986cb;\n    color: #fff;\n  }\n  .calendar__day--start:hover,\n  .calendar__day--end:hover,\n  .calendar__day--selected:hover {\n    background: #7986cb;\n  }\n  .calendar__day--range {\n    background: #dce1ff;\n  }\n  .calendar__day--text {\n    display: block;\n    font-size: 10px;\n  }\n  .calendar__year,\n  .calendar__month {\n    height: 55px;\n    vertical-align: middle;\n  }\n  .calendar__year:hover,\n  .calendar__month:hover {\n    background: #aab6fe;\n    cursor: pointer;\n  }\n  \n  /* Selector Design */\n  .css-1okebmr-indicatorSeparator {\n    display: none;\n  }\n  \n  /* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
